module.exports = __webpack_public_path__ + "img/choose.87c76cad.svg";